import React from 'react';
import { Box } from '@chakra-ui/react';
import { TermsOfService } from '../features/terms-of-service';
import { ScrollToTop } from '../features/navigation';

const TermsOfServicePage: React.FC = () => {
  return (
    <Box as="main" flex="1">
      <TermsOfService />
      <ScrollToTop />
    </Box>
  );
};

export default TermsOfServicePage;